import { render } from "./BaseAddZone.vue?vue&type=template&id=1ed040a8&scoped=true"
import script from "./BaseAddZone.vue?vue&type=script&lang=js"
export * from "./BaseAddZone.vue?vue&type=script&lang=js"

import "./BaseAddZone.vue?vue&type=style&index=0&id=1ed040a8&scoped=true&lang=scss"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed040a8"]])

export default __exports__